<ng-container>
  <div class="flex flex-row min-h-screen">
    <app-side-bar 
    [isDashboardOpen]="isUserInsideDashboard"
     class="relative z-[2]" [pageName]="currentPage" (openFeedbackModal)="toggleFeedback($event)"></app-side-bar>

     <div class="flex-1 flex flex-col bg-gray-50 pt-5 2xl:pt-6 min-h-full">
   <!--   <app-header 
      (isUserInDashboard)=" handleDashboardStatus()"
      (currentPageChange)="onCurrentPageChange($event)"></app-header> -->
      <main class="flex-1 min-w-[900px] overflow-x-auto overflow-y-hidden text-black">
        <router-outlet></router-outlet>
     </main>
    </div>
  </div>
</ng-container>

<!-- USE IT JUST TO WORK WITH SCREEN SIZES AND MEDIA QUERIES -->
<!--<app-window-size-tool></app-window-size-tool>-->

<ng-container *ngIf="isFeedbackOpen">
<app-feedback (openFeedbackModal)="toggleFeedback($event)"></app-feedback>
</ng-container>